/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingCard_listing$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsItems_aggregatesListings$ref: FragmentReference;
declare export opaque type AggregatesListingsItems_aggregatesListings$fragmentType: AggregatesListingsItems_aggregatesListings$ref;
export type AggregatesListingsItems_aggregatesListings = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: {|
      +id: string,
      +title: ?string,
      +slug: string,
      +propertyMainType: ?string,
      +propertyType: ?string,
      +compositePropertyType: CompositePropertyType,
      +portal: string,
      +offerType: OfferType,
      +salePrice: ?number,
      +grossRentMonthly: ?number,
      +postcode: ?string,
      +subLocality: ?string,
      +locality: ?string,
      +lat: ?number,
      +lng: ?number,
      +computedSurface: ?number,
      +numberOfRooms: ?number,
      +numberOfBathrooms: ?number,
      +numberOfParking: ?number,
      +constructionYear: ?number,
      +renovationYear: ?number,
      +agencyId: ?string,
      +agencyName: ?string,
      +$fragmentRefs: AggregatesListingCard_listing$ref,
    |}
  |}>,
  +$refType: AggregatesListingsItems_aggregatesListings$ref,
|};
export type AggregatesListingsItems_aggregatesListings$data = AggregatesListingsItems_aggregatesListings;
export type AggregatesListingsItems_aggregatesListings$key = {
  +$data?: AggregatesListingsItems_aggregatesListings$data,
  +$fragmentRefs: AggregatesListingsItems_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsItems_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatesListing",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyMainType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "propertyType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "compositePropertyType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "portal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "offerType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "salePrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "grossRentMonthly",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "postcode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subLocality",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "locality",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lng",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "computedSurface",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfRooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfBathrooms",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfParking",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "constructionYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "renovationYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "agencyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "agencyName",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "filters",
                  "variableName": "filters"
                }
              ],
              "kind": "FragmentSpread",
              "name": "AggregatesListingCard_listing"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e2c07c0ec27b464a568022dcef612bcf';

export default node;
